module.exports = __webpack_public_path__ + "img/icon-title-3.a6ca1a98.png";